import React, { Component, Fragment } from 'react';
import { ModalBody, ModalFooter } from 'reactstrap';
import classNames from 'classnames';
import ListActionSubheader from '../ListActionSubheader';
import PropertyActions from '../PropertyActions';
import Modal from '../../../../shared/ui/Modal';
import AddActionButton from '../AddActionButton';

class PhoneList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDeleteMessage: '',
      deleteIndex: -1,
      isModalOpen: false,
    };
  }

  // ----------------------
  // Computed
  // ----------------------

  getPhonePropertyActions(isDefault) {
    const editPhone = {
      label: 'Edit',
      handlerProp: 'onEdit',
      icon: 'edit',
    };
    const setDefault = {
      label: 'Set Default',
      handlerProp: 'onSetDefault',
      icon: 'check',
    };
    const deletePhone = {
      label: 'Delete',
      handlerProp: 'onDelete',
      icon: 'trash',
    };
    return isDefault ? [editPhone] : [setDefault, editPhone, deletePhone];
  }

  // ----------------------
  // Methods
  // ----------------------

  confirmDeletePhone(deleteIndex) {
    const phoneToDelete = this.props.phones.find((phone, arrayIndex) => {
      return arrayIndex === deleteIndex;
    });
    this.setState({
      confirmDeleteMessage: `Delete phone labelled "${phoneToDelete.label}"?`,
      deleteIndex,
      isModalOpen: true,
    });
  }

  deletePhone(deleteIndex) {
    this.setState({
      confirmDeleteMessage: '',
      deleteIndex: -1,
      isModalOpen: false,
    });
    this.props.onDelete(deleteIndex);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <ListActionSubheader title="Phone Numbers">
          { this.props.canAddEdit !== false &&
            <AddActionButton label="Phone" onAdd={() => this.props.onAdd()} />
          }
        </ListActionSubheader>
        <div className="profile-list">
          {this.props.phones.length > 0 ? (
            this.props.phones.map((phone, index) => (
              <div
                className={classNames('profile-list-item', {
                  'is-default': phone.isDefault,
                })}
                key={index.toString()}
              >
                <div className="profile-list-item-selected">
                  <i className="fa fa-check" />
                </div>
                <div className="profile-list-content">
                  <b>{phone.label}</b>
                  <span>{phone.phoneNumber}</span>
                </div>
                <div className="profile-list-actions">
                  {this.props.canAddEdit !== false &&
                    <PropertyActions
                      actions={this.getPhonePropertyActions(phone.isDefault)}
                      onDelete={() => this.confirmDeletePhone(index)}
                      onEdit={() => this.props.onEdit(index)}
                      onSetDefault={() => this.props.onSetDefault(index)}
                    />
                  }
                </div>
              </div>
            ))
          ) : (
            <div className="profile-list-item">No phones found</div>
          )}
        </div>
        <Modal
          isOpen={this.state.isModalOpen}
          onClose={() => this.setState({ isModalOpen: false })}
          title="Confirm Delete Phone"
        >
          <ModalBody>{this.state.confirmDeleteMessage}</ModalBody>
          <ModalFooter>
            <button
              className="button primary"
              onClick={() => this.deletePhone(this.state.deleteIndex)}
            >
              Delete
            </button>
            <button
              className="button"
              onClick={() => this.setState({ isModalOpen: false })}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default PhoneList;
